function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t.return || t.return();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _superPropGet(t, o, e, r) {
  var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e);
  return 2 & r && "function" == typeof p ? function (t) {
    return p.apply(e, t);
  } : p;
}
function _get() {
  return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
    var p = _superPropBase(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
    }
  }, _get.apply(null, arguments);
}
function _superPropBase(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t)););
  return t;
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
var $ = Object.defineProperty;
var U = function U(n, s, e) {
  return s in n ? $(n, s, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: e
  }) : n[s] = e;
};
var p = function p(n, s, e) {
  return U(n, _typeof(s) != "symbol" ? s + "" : s, e);
};
import { Plugin as P } from "../../../../../@ckeditor_ckeditor5-core@45.1.0/node_modules/@ckeditor/ckeditor5-core/dist/index.js";
import { MouseObserver as D, TreeWalker as q } from "../../../../../@ckeditor_ckeditor5-engine@45.1.0/node_modules/@ckeditor/ckeditor5-engine/dist/index.js";
import { Delete as I } from "../../../../../@ckeditor_ckeditor5-typing@45.1.0/node_modules/@ckeditor/ckeditor5-typing/dist/index.js";
import { keyCodes as T, env as O, getLocalizedArrowKeyCodeDirection as G, logWarning as Y, CKEditorError as F, isForwardArrowKeyCode as X, getRangeFromMouseEvent as J, global as A, DomEmitterMixin as Q, toArray as N, Rect as v, ObservableMixin as M, compareArrays as Z, EmitterMixin as ee } from "../../../../../@ckeditor_ckeditor5-utils@45.1.0/node_modules/@ckeditor/ckeditor5-utils/dist/index.js";
import { IconReturnArrow as te, IconDragHandle as ie } from "../../../../../@ckeditor_ckeditor5-icons@45.1.0/node_modules/@ckeditor/ckeditor5-icons/dist/index.js";
import { ContextualBalloon as oe, ToolbarView as ne, BalloonPanelView as se, IconView as re, Template as k, View as le } from "../../../../../@ckeditor_ckeditor5-ui@45.1.0/node_modules/@ckeditor/ckeditor5-ui/dist/index.js";
import { Enter as ce } from "../../../../../@ckeditor_ckeditor5-enter@45.1.0/node_modules/@ckeditor/ckeditor5-enter/dist/index.js";
import { throttle as ae } from "../../../../../es-toolkit@1.32.0/node_modules/es-toolkit/dist/compat/function/throttle.js"; /**
                                                                                                                            * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
                                                                                                                            * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
                                                                                                                            */
var de = /*#__PURE__*/function (_ee) {
  function de() {
    var _this;
    _classCallCheck(this, de);
    _this = _callSuper(this, de, arguments);
    p(_this, "_stack", []);
    return _this;
  }
  _inherits(de, _ee);
  return _createClass(de, [{
    key: "add",
    value: function add(e, t) {
      var i = this._stack,
        o = i[0];
      this._insertDescriptor(e);
      var r = i[0];
      o !== r && !C(o, r) && this.fire("change:top", {
        oldDescriptor: o,
        newDescriptor: r,
        writer: t
      });
    }
  }, {
    key: "remove",
    value: function remove(e, t) {
      var i = this._stack,
        o = i[0];
      this._removeDescriptor(e);
      var r = i[0];
      o !== r && !C(o, r) && this.fire("change:top", {
        oldDescriptor: o,
        newDescriptor: r,
        writer: t
      });
    }
  }, {
    key: "_insertDescriptor",
    value: function _insertDescriptor(e) {
      var t = this._stack,
        i = t.findIndex(function (r) {
          return r.id === e.id;
        });
      if (C(e, t[i])) return;
      i > -1 && t.splice(i, 1);
      var o = 0;
      for (; t[o] && he(t[o], e);) o++;
      t.splice(o, 0, e);
    }
  }, {
    key: "_removeDescriptor",
    value: function _removeDescriptor(e) {
      var t = this._stack,
        i = t.findIndex(function (o) {
          return o.id === e;
        });
      i > -1 && t.splice(i, 1);
    }
  }]);
}(ee());
function C(n, s) {
  return n && s && n.priority == s.priority && S(n.classes) == S(s.classes);
}
function he(n, s) {
  return n.priority > s.priority ? !0 : n.priority < s.priority ? !1 : S(n.classes) > S(s.classes);
}
function S(n) {
  return Array.isArray(n) ? n.sort().join(",") : n;
}
var ue = "ck-widget",
  R = "ck-widget_selected";
function m(n) {
  return n.is("element") ? !!n.getCustomProperty("widget") : !1;
}
function nt(n, s) {
  var e = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  if (!n.is("containerElement")) throw new F("widget-to-widget-wrong-element-type", null, {
    element: n
  });
  return s.setAttribute("contenteditable", "false", n), s.addClass(ue, n), s.setCustomProperty("widget", !0, n), n.getFillerOffset = we, s.setCustomProperty("widgetLabel", [], n), e.label && fe(n, e.label), e.hasSelectionHandle && _e(n, s), L(n, s), n;
}
function ge(n, s, e) {
  if (s.classes && e.addClass(N(s.classes), n), s.attributes) for (var t in s.attributes) e.setAttribute(t, s.attributes[t], n);
}
function pe(n, s, e) {
  if (s.classes && e.removeClass(N(s.classes), n), s.attributes) for (var t in s.attributes) e.removeAttribute(t, n);
}
function L(n, s) {
  var e = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ge;
  var t = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : pe;
  var i = new de();
  i.on("change:top", function (l, c) {
    c.oldDescriptor && t(n, c.oldDescriptor, c.writer), c.newDescriptor && e(n, c.newDescriptor, c.writer);
  });
  var o = function o(l, c, a) {
      return i.add(c, a);
    },
    r = function r(l, c, a) {
      return i.remove(c, a);
    };
  s.setCustomProperty("addHighlight", o, n), s.setCustomProperty("removeHighlight", r, n);
}
function fe(n, s) {
  n.getCustomProperty("widgetLabel").push(s);
}
function me(n) {
  return n.getCustomProperty("widgetLabel").reduce(function (e, t) {
    return typeof t == "function" ? e ? e + ". " + t() : t() : e ? e + ". " + t : t;
  }, "");
}
function st(n, s) {
  var e = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return s.addClass(["ck-editor__editable", "ck-editor__nested-editable"], n), e.withAriaRole !== !1 && s.setAttribute("role", "textbox", n), s.setAttribute("tabindex", "-1", n), e.label && s.setAttribute("aria-label", e.label, n), s.setAttribute("contenteditable", n.isReadOnly ? "false" : "true", n), n.on("change:isReadOnly", function (t, i, o) {
    s.setAttribute("contenteditable", o ? "false" : "true", n);
  }), n.on("change:isFocused", function (t, i, o) {
    o ? s.addClass("ck-editor__nested-editable_focused", n) : s.removeClass("ck-editor__nested-editable_focused", n);
  }), L(n, s), n;
}
function rt(n, s) {
  var e = n.getSelectedElement();
  if (e) {
    var t = b(n);
    if (t) return s.createRange(s.createPositionAt(e, t));
  }
  return s.schema.findOptimalInsertionRange(n);
}
function we() {
  return null;
}
function _e(n, s) {
  var e = s.createUIElement("div", {
    class: "ck ck-widget__selection-handle"
  }, function (t) {
    var i = this.toDomElement(t),
      o = new re();
    return o.set("content", ie), o.render(), i.appendChild(o.element), i;
  });
  s.insert(s.createPositionAt(n, 0), e), s.addClass(["ck-widget_with-selection-handle"], n);
}
function be(n) {
  var s = function s(l) {
      var _l$ownerDocument$defa = l.ownerDocument.defaultView.getComputedStyle(l),
        c = _l$ownerDocument$defa.width,
        a = _l$ownerDocument$defa.paddingLeft,
        d = _l$ownerDocument$defa.paddingRight;
      return parseFloat(c) - (parseFloat(a) || 0) - (parseFloat(d) || 0);
    },
    e = n.parentElement;
  if (!e) return 0;
  var t = s(e);
  var i = 5;
  var o = 0,
    r = e;
  for (; isNaN(t);) {
    if (r = r.parentElement, ++o > i) return 0;
    t = s(r);
  }
  return t;
}
function ye(n) {
  var s = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new v(n);
  var e = be(n);
  return e ? s.width / e * 100 : 0;
}
var _ = "widget-type-around";
function y(n, s, e) {
  return !!n && m(n) && !e.isInline(s);
}
function ve(n) {
  return n.closest(".ck-widget__type-around__button");
}
function Ee(n) {
  return n.classList.contains("ck-widget__type-around__button_before") ? "before" : "after";
}
function Se(n, s) {
  var e = n.closest(".ck-widget");
  return s.mapDomToView(e);
}
function b(n) {
  return n.getAttribute(_);
}
var B = ["before", "after"],
  Pe = new DOMParser().parseFromString(te, "image/svg+xml").firstChild,
  W = "ck-widget__type-around_disabled";
var Ce = /*#__PURE__*/function (_P) {
  function Ce() {
    var _this2;
    _classCallCheck(this, Ce);
    _this2 = _callSuper(this, Ce, arguments);
    p(_this2, "_currentFakeCaretModelElement", null);
    return _this2;
  }
  _inherits(Ce, _P);
  return _createClass(Ce, [{
    key: "init",
    value: function init() {
      var e = this.editor,
        t = e.editing.view;
      this.on("change:isEnabled", function (i, o, r) {
        t.change(function (l) {
          var _iterator = _createForOfIteratorHelper(t.document.roots),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var c = _step.value;
              r ? l.removeClass(W, c) : l.addClass(W, c);
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        }), r || e.model.change(function (l) {
          l.removeSelectionAttribute(_);
        });
      }), this._enableTypeAroundUIInjection(), this._enableInsertingParagraphsOnButtonClick(), this._enableInsertingParagraphsOnEnterKeypress(), this._enableInsertingParagraphsOnTypingKeystroke(), this._enableTypeAroundFakeCaretActivationUsingKeyboardArrows(), this._enableDeleteIntegration(), this._enableInsertContentIntegration(), this._enableInsertObjectIntegration(), this._enableDeleteContentIntegration();
    }
  }, {
    key: "destroy",
    value: function destroy() {
      _superPropGet(Ce, "destroy", this, 3)([]), this._currentFakeCaretModelElement = null;
    }
  }, {
    key: "_insertParagraph",
    value: function _insertParagraph(e, t) {
      var i = this.editor,
        o = i.editing.view,
        r = i.model.schema.getAttributesWithProperty(e, "copyOnReplace", !0);
      i.execute("insertParagraph", {
        position: i.model.createPositionAt(e, t),
        attributes: r
      }), o.focus(), o.scrollToTheSelection();
    }
  }, {
    key: "_listenToIfEnabled",
    value: function _listenToIfEnabled(e, t, i, o) {
      var _this3 = this;
      this.listenTo(e, t, function () {
        _this3.isEnabled && i.apply(void 0, arguments);
      }, o);
    }
  }, {
    key: "_insertParagraphAccordingToFakeCaretPosition",
    value: function _insertParagraphAccordingToFakeCaretPosition() {
      var i = this.editor.model.document.selection,
        o = b(i);
      if (!o) return !1;
      var r = i.getSelectedElement();
      return this._insertParagraph(r, o), !0;
    }
  }, {
    key: "_enableTypeAroundUIInjection",
    value: function _enableTypeAroundUIInjection() {
      var _this4 = this;
      var e = this.editor,
        t = e.model.schema,
        i = e.locale.t,
        o = {
          before: i("Insert paragraph before block"),
          after: i("Insert paragraph after block")
        };
      e.editing.downcastDispatcher.on("insert", function (r, l, c) {
        var a = c.mapper.toViewElement(l.item);
        a && y(a, l.item, t) && (Te(c.writer, o, a), a.getCustomProperty("widgetLabel").push(function () {
          return _this4.isEnabled ? i("Press Enter to type after or press Shift + Enter to type before the widget") : "";
        }));
      }, {
        priority: "low"
      });
    }
  }, {
    key: "_enableTypeAroundFakeCaretActivationUsingKeyboardArrows",
    value: function _enableTypeAroundFakeCaretActivationUsingKeyboardArrows() {
      var _this5 = this;
      var e = this.editor,
        t = e.model,
        i = t.document.selection,
        o = t.schema,
        r = e.editing.view;
      this._listenToIfEnabled(r.document, "arrowKey", function (c, a) {
        _this5._handleArrowKeyPress(c, a);
      }, {
        context: [m, "$text"],
        priority: "high"
      }), this._listenToIfEnabled(i, "change:range", function (c, a) {
        a.directChange && e.model.change(function (d) {
          d.removeSelectionAttribute(_);
        });
      }), this._listenToIfEnabled(t.document, "change:data", function () {
        var c = i.getSelectedElement();
        if (c) {
          var a = e.editing.mapper.toViewElement(c);
          if (y(a, c, o)) return;
        }
        e.model.change(function (a) {
          a.removeSelectionAttribute(_);
        });
      }), this._listenToIfEnabled(e.editing.downcastDispatcher, "selection", function (c, a, d) {
        var u = d.writer;
        if (_this5._currentFakeCaretModelElement) {
          var w = d.mapper.toViewElement(_this5._currentFakeCaretModelElement);
          w && (u.removeClass(B.map(l), w), _this5._currentFakeCaretModelElement = null);
        }
        var h = a.selection.getSelectedElement();
        if (!h) return;
        var f = d.mapper.toViewElement(h);
        if (!y(f, h, o)) return;
        var g = b(a.selection);
        g && (u.addClass(l(g), f), _this5._currentFakeCaretModelElement = h);
      }), this._listenToIfEnabled(e.ui.focusTracker, "change:isFocused", function (c, a, d) {
        d || e.model.change(function (u) {
          u.removeSelectionAttribute(_);
        });
      });
      function l(c) {
        return "ck-widget_type-around_show-fake-caret_".concat(c);
      }
    }
  }, {
    key: "_handleArrowKeyPress",
    value: function _handleArrowKeyPress(e, t) {
      var i = this.editor,
        o = i.model,
        r = o.document.selection,
        l = o.schema,
        c = i.editing.view,
        a = t.keyCode,
        d = X(a, i.locale.contentLanguageDirection),
        u = c.document.selection.getSelectedElement(),
        h = i.editing.mapper.toModelElement(u);
      var f;
      y(u, h, l) ? f = this._handleArrowKeyPressOnSelectedWidget(d) : r.isCollapsed ? f = this._handleArrowKeyPressWhenSelectionNextToAWidget(d) : t.shiftKey || (f = this._handleArrowKeyPressWhenNonCollapsedSelection(d)), f && (t.preventDefault(), e.stop());
    }
  }, {
    key: "_handleArrowKeyPressOnSelectedWidget",
    value: function _handleArrowKeyPressOnSelectedWidget(e) {
      var i = this.editor.model,
        o = i.document.selection,
        r = b(o);
      return i.change(function (l) {
        if (r) {
          if (!(r === (e ? "after" : "before"))) return l.removeSelectionAttribute(_), !0;
        } else return l.setSelectionAttribute(_, e ? "after" : "before"), !0;
        return !1;
      });
    }
  }, {
    key: "_handleArrowKeyPressWhenSelectionNextToAWidget",
    value: function _handleArrowKeyPressWhenSelectionNextToAWidget(e) {
      var t = this.editor,
        i = t.model,
        o = i.schema,
        r = t.plugins.get("Widget"),
        l = r._getObjectElementNextToSelection(e),
        c = t.editing.mapper.toViewElement(l);
      return y(c, l, o) ? (i.change(function (a) {
        r._setSelectionOverElement(l), a.setSelectionAttribute(_, e ? "before" : "after");
      }), !0) : !1;
    }
  }, {
    key: "_handleArrowKeyPressWhenNonCollapsedSelection",
    value: function _handleArrowKeyPressWhenNonCollapsedSelection(e) {
      var t = this.editor,
        i = t.model,
        o = i.schema,
        r = t.editing.mapper,
        l = i.document.selection,
        c = e ? l.getLastPosition().nodeBefore : l.getFirstPosition().nodeAfter,
        a = r.toViewElement(c);
      return y(a, c, o) ? (i.change(function (d) {
        d.setSelection(c, "on"), d.setSelectionAttribute(_, e ? "after" : "before");
      }), !0) : !1;
    }
  }, {
    key: "_enableInsertingParagraphsOnButtonClick",
    value: function _enableInsertingParagraphsOnButtonClick() {
      var _this6 = this;
      var e = this.editor,
        t = e.editing.view;
      this._listenToIfEnabled(t.document, "mousedown", function (i, o) {
        var r = ve(o.domTarget);
        if (!r) return;
        var l = Ee(r),
          c = Se(r, t.domConverter),
          a = e.editing.mapper.toModelElement(c);
        _this6._insertParagraph(a, l), o.preventDefault(), i.stop();
      });
    }
  }, {
    key: "_enableInsertingParagraphsOnEnterKeypress",
    value: function _enableInsertingParagraphsOnEnterKeypress() {
      var _this7 = this;
      var e = this.editor,
        t = e.model.document.selection,
        i = e.editing.view;
      this._listenToIfEnabled(i.document, "enter", function (o, r) {
        if (o.eventPhase != "atTarget") return;
        var l = t.getSelectedElement(),
          c = e.editing.mapper.toViewElement(l),
          a = e.model.schema;
        var d;
        _this7._insertParagraphAccordingToFakeCaretPosition() ? d = !0 : y(c, l, a) && (_this7._insertParagraph(l, r.isSoft ? "before" : "after"), d = !0), d && (r.preventDefault(), o.stop());
      }, {
        context: m
      });
    }
  }, {
    key: "_enableInsertingParagraphsOnTypingKeystroke",
    value: function _enableInsertingParagraphsOnTypingKeystroke() {
      var _this8 = this;
      var t = this.editor.editing.view.document;
      this._listenToIfEnabled(t, "insertText", function (i, o) {
        _this8._insertParagraphAccordingToFakeCaretPosition() && (o.selection = t.selection);
      }, {
        priority: "high"
      }), O.isAndroid ? this._listenToIfEnabled(t, "keydown", function (i, o) {
        o.keyCode == 229 && _this8._insertParagraphAccordingToFakeCaretPosition();
      }) : this._listenToIfEnabled(t, "compositionstart", function () {
        _this8._insertParagraphAccordingToFakeCaretPosition();
      }, {
        priority: "highest"
      });
    }
  }, {
    key: "_enableDeleteIntegration",
    value: function _enableDeleteIntegration() {
      var e = this.editor,
        t = e.editing.view,
        i = e.model,
        o = i.schema;
      this._listenToIfEnabled(t.document, "delete", function (r, l) {
        if (r.eventPhase != "atTarget") return;
        var c = b(i.document.selection);
        if (!c) return;
        var a = l.direction,
          d = i.document.selection.getSelectedElement(),
          u = c === "before",
          h = a == "forward";
        if (u === h) e.execute("delete", {
          selection: i.createSelection(d, "on")
        });else {
          var g = o.getNearestSelectionRange(i.createPositionAt(d, c), a);
          if (g) if (!g.isCollapsed) i.change(function (w) {
            w.setSelection(g), e.execute(h ? "deleteForward" : "delete");
          });else {
            var w = i.createSelection(g.start);
            if (i.modifySelection(w, {
              direction: a
            }), !w.focus.isEqual(g.start)) i.change(function (E) {
              E.setSelection(g), e.execute(h ? "deleteForward" : "delete");
            });else {
              var E = Re(o, g.start.parent);
              i.deleteContent(i.createSelection(E, "on"), {
                doNotAutoparagraph: !0
              });
            }
          }
        }
        l.preventDefault(), r.stop();
      }, {
        context: m
      });
    }
  }, {
    key: "_enableInsertContentIntegration",
    value: function _enableInsertContentIntegration() {
      var e = this.editor,
        t = this.editor.model,
        i = t.document.selection;
      this._listenToIfEnabled(e.model, "insertContent", function (o, _ref) {
        var _ref2 = _slicedToArray(_ref, 2),
          r = _ref2[0],
          l = _ref2[1];
        if (l && !l.is("documentSelection")) return;
        var c = b(i);
        if (c) return o.stop(), t.change(function (a) {
          var d = i.getSelectedElement(),
            u = t.createPositionAt(d, c),
            h = a.createSelection(u),
            f = t.insertContent(r, h);
          return a.setSelection(h), f;
        });
      }, {
        priority: "high"
      });
    }
  }, {
    key: "_enableInsertObjectIntegration",
    value: function _enableInsertObjectIntegration() {
      var e = this.editor,
        i = this.editor.model.document.selection;
      this._listenToIfEnabled(e.model, "insertObject", function (o, r) {
        var _r = _slicedToArray(r, 3),
          l = _r[1],
          _r$ = _r[2],
          c = _r$ === void 0 ? {} : _r$;
        if (l && !l.is("documentSelection")) return;
        var a = b(i);
        a && (c.findOptimalPosition = a, r[3] = c);
      }, {
        priority: "high"
      });
    }
  }, {
    key: "_enableDeleteContentIntegration",
    value: function _enableDeleteContentIntegration() {
      var e = this.editor,
        i = this.editor.model.document.selection;
      this._listenToIfEnabled(e.model, "deleteContent", function (o, _ref3) {
        var _ref4 = _slicedToArray(_ref3, 1),
          r = _ref4[0];
        if (r && !r.is("documentSelection")) return;
        b(i) && o.stop();
      }, {
        priority: "high"
      });
    }
  }], [{
    key: "pluginName",
    get: function get() {
      return "WidgetTypeAround";
    }
  }, {
    key: "isOfficialPlugin",
    get: function get() {
      return !0;
    }
  }, {
    key: "requires",
    get: function get() {
      return [ce, I];
    }
  }]);
}(P);
function Te(n, s, e) {
  var t = n.createUIElement("div", {
    class: "ck ck-reset_all ck-widget__type-around"
  }, function (i) {
    var o = this.toDomElement(i);
    return ke(o, s), Ae(o), o;
  });
  n.insert(n.createPositionAt(e, "end"), t);
}
function ke(n, s) {
  for (var _i = 0, _B = B; _i < _B.length; _i++) {
    var e = _B[_i];
    var t = new k({
      tag: "div",
      attributes: {
        class: ["ck", "ck-widget__type-around__button", "ck-widget__type-around__button_".concat(e)],
        title: s[e],
        "aria-hidden": "true"
      },
      children: [n.ownerDocument.importNode(Pe, !0)]
    });
    n.appendChild(t.render());
  }
}
function Ae(n) {
  var s = new k({
    tag: "div",
    attributes: {
      class: ["ck", "ck-widget__type-around__fake-caret"]
    }
  });
  n.appendChild(s.render());
}
function Re(n, s) {
  var e = s;
  var _iterator2 = _createForOfIteratorHelper(s.getAncestors({
      parentFirst: !0
    })),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var t = _step2.value;
      if (t.childCount > 1 || n.isLimit(t)) break;
      e = t;
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  return e;
}
function We(n) {
  var s = n.model;
  return function (e, t) {
    var i = t.keyCode == T.arrowup,
      o = t.keyCode == T.arrowdown,
      r = t.shiftKey,
      l = s.document.selection;
    if (!i && !o) return;
    var c = o;
    if (r && He(l, c)) return;
    var a = ze(n, l, c);
    if (a) {
      if (a.isCollapsed) {
        if (l.isCollapsed) return;
        if (r) return;
      }
      (a.isCollapsed || xe(n, a, c)) && (s.change(function (d) {
        var u = c ? a.end : a.start;
        if (r) {
          var h = s.createSelection(l.anchor);
          h.setFocus(u), d.setSelection(h);
        } else d.setSelection(u);
      }), e.stop(), t.preventDefault(), t.stopPropagation());
    }
  };
}
function ze(n, s, e) {
  var t = n.model;
  if (e) {
    var i = s.isCollapsed ? s.focus : s.getLastPosition(),
      o = z(t, i, "forward");
    if (!o) return null;
    var r = t.createRange(i, o),
      l = x(t.schema, r, "backward");
    return l ? t.createRange(i, l) : null;
  } else {
    var _i2 = s.isCollapsed ? s.focus : s.getFirstPosition(),
      _o = z(t, _i2, "backward");
    if (!_o) return null;
    var _r2 = t.createRange(_o, _i2),
      _l = x(t.schema, _r2, "forward");
    return _l ? t.createRange(_l, _i2) : null;
  }
}
function z(n, s, e) {
  var t = n.schema,
    i = n.createRangeIn(s.root),
    o = e == "forward" ? "elementStart" : "elementEnd";
  var _iterator3 = _createForOfIteratorHelper(i.getWalker({
      startPosition: s,
      direction: e
    })),
    _step3;
  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var _ref5 = _step3.value;
      var r = _ref5.previousPosition;
      var l = _ref5.item;
      var c = _ref5.type;
      if (t.isLimit(l) && !t.isInline(l)) return r;
      if (c == o && t.isBlock(l)) return null;
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }
  return null;
}
function x(n, s, e) {
  var t = e == "backward" ? s.end : s.start;
  if (n.checkChild(t, "$text")) return t;
  var _iterator4 = _createForOfIteratorHelper(s.getWalker({
      direction: e
    })),
    _step4;
  try {
    for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
      var _ref6 = _step4.value;
      var i = _ref6.nextPosition;
      if (n.checkChild(i, "$text")) return i;
    }
  } catch (err) {
    _iterator4.e(err);
  } finally {
    _iterator4.f();
  }
  return null;
}
function xe(n, s, e) {
  var t = n.model,
    i = n.view.domConverter;
  if (e) {
    var a = t.createSelection(s.start);
    t.modifySelection(a), !a.focus.isAtEnd && !s.start.isEqual(a.focus) && (s = t.createRange(a.focus, s.end));
  }
  var o = n.mapper.toViewRange(s),
    r = i.viewRangeToDom(o),
    l = v.getDomRangeRects(r);
  var c;
  var _iterator5 = _createForOfIteratorHelper(l),
    _step5;
  try {
    for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
      var _a = _step5.value;
      if (c === void 0) {
        c = Math.round(_a.bottom);
        continue;
      }
      if (Math.round(_a.top) >= c) return !1;
      c = Math.max(c, Math.round(_a.bottom));
    }
  } catch (err) {
    _iterator5.e(err);
  } finally {
    _iterator5.f();
  }
  return !0;
}
function He(n, s) {
  return !n.isCollapsed && n.isBackward == s;
}
var lt = /*#__PURE__*/function (_P2) {
  function lt() {
    var _this9;
    _classCallCheck(this, lt);
    _this9 = _callSuper(this, lt, arguments);
    p(_this9, "_previouslySelected", new Set());
    return _this9;
  }
  _inherits(lt, _P2);
  return _createClass(lt, [{
    key: "init",
    value: function init() {
      var _this0 = this;
      var e = this.editor,
        t = e.editing.view,
        i = t.document,
        o = e.t;
      this.editor.editing.downcastDispatcher.on("selection", function (r, l, c) {
        var a = c.writer,
          d = l.selection;
        if (d.isCollapsed) return;
        var u = d.getSelectedElement();
        if (!u) return;
        var h = e.editing.mapper.toViewElement(u);
        m(h) && c.consumable.consume(d, "selection") && a.setSelection(a.createRangeOn(h), {
          fake: !0,
          label: me(h)
        });
      }), this.editor.editing.downcastDispatcher.on("selection", function (r, l, c) {
        _this0._clearPreviouslySelectedWidgets(c.writer);
        var a = c.writer,
          d = a.document.selection;
        var u = null;
        var _iterator6 = _createForOfIteratorHelper(d.getRanges()),
          _step6;
        try {
          for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
            var h = _step6.value;
            var _iterator7 = _createForOfIteratorHelper(h),
              _step7;
            try {
              for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
                var f = _step7.value;
                var g = f.item;
                m(g) && !Ie(g, u) && (a.addClass(R, g), _this0._previouslySelected.add(g), u = g);
              }
            } catch (err) {
              _iterator7.e(err);
            } finally {
              _iterator7.f();
            }
          }
        } catch (err) {
          _iterator6.e(err);
        } finally {
          _iterator6.f();
        }
      }, {
        priority: "low"
      }), t.addObserver(D), this.listenTo(i, "mousedown", function () {
        return _this0._onMousedown.apply(_this0, arguments);
      }), this.listenTo(i, "arrowKey", function () {
        _this0._handleSelectionChangeOnArrowKeyPress.apply(_this0, arguments);
      }, {
        context: [m, "$text"]
      }), this.listenTo(i, "arrowKey", function () {
        _this0._preventDefaultOnArrowKeyPress.apply(_this0, arguments);
      }, {
        context: "$root"
      }), this.listenTo(i, "arrowKey", We(this.editor.editing), {
        context: "$text"
      }), this.listenTo(i, "delete", function (r, l) {
        _this0._handleDelete(l.direction == "forward") && (l.preventDefault(), r.stop());
      }, {
        context: "$root"
      }), this.listenTo(i, "tab", function (r, l) {
        r.eventPhase == "atTarget" && (l.shiftKey || _this0._selectFirstNestedEditable() && (l.preventDefault(), r.stop()));
      }, {
        context: m,
        priority: "low"
      }), this.listenTo(i, "tab", function (r, l) {
        l.shiftKey && _this0._selectAncestorWidget() && (l.preventDefault(), r.stop());
      }, {
        priority: "low"
      }), this.listenTo(i, "keydown", function (r, l) {
        l.keystroke == T.esc && _this0._selectAncestorWidget() && (l.preventDefault(), r.stop());
      }, {
        priority: "low"
      }), e.accessibility.addKeystrokeInfoGroup({
        id: "widget",
        label: o("Keystrokes that can be used when a widget is selected (for example: image, table, etc.)"),
        keystrokes: [{
          label: o("Move focus from an editable area back to the parent widget"),
          keystroke: "Esc"
        }, {
          label: o("Insert a new paragraph directly after a widget"),
          keystroke: "Enter"
        }, {
          label: o("Insert a new paragraph directly before a widget"),
          keystroke: "Shift+Enter"
        }, {
          label: o("Move the caret to allow typing directly before a widget"),
          keystroke: [["arrowup"], ["arrowleft"]]
        }, {
          label: o("Move the caret to allow typing directly after a widget"),
          keystroke: [["arrowdown"], ["arrowright"]]
        }]
      });
    }
  }, {
    key: "_onMousedown",
    value: function _onMousedown(e, t) {
      var i = this.editor,
        o = i.editing.view,
        r = o.document;
      var l = t.target;
      if (!l) return;
      if (t.domEvent.detail >= 3) {
        this._selectBlockContent(l) && t.preventDefault();
        return;
      }
      if (!m(l)) {
        var a = Ve(l);
        if (!a) return;
        if (m(a)) l = a;else {
          var d = De(o, t);
          if (d && m(d)) l = d;else return;
        }
      }
      O.isAndroid && t.preventDefault(), r.isFocused || o.focus();
      var c = i.editing.mapper.toModelElement(l);
      this._setSelectionOverElement(c);
    }
  }, {
    key: "_selectBlockContent",
    value: function _selectBlockContent(e) {
      var t = this.editor,
        i = t.model,
        o = t.editing.mapper,
        r = i.schema,
        l = o.findMappedViewAncestor(this.editor.editing.view.createPositionAt(e, 0)),
        c = Oe(o.toModelElement(l), i.schema);
      return c ? (i.change(function (a) {
        var d = r.isLimit(c) ? null : Fe(a.createPositionAfter(c), r),
          u = a.createPositionAt(c, 0),
          h = d ? a.createPositionAt(d, 0) : a.createPositionAt(c, "end");
        a.setSelection(a.createRange(u, h));
      }), !0) : !1;
    }
  }, {
    key: "_handleSelectionChangeOnArrowKeyPress",
    value: function _handleSelectionChangeOnArrowKeyPress(e, t) {
      var i = t.keyCode,
        o = this.editor.model,
        r = o.schema,
        l = o.document.selection,
        c = l.getSelectedElement(),
        a = G(i, this.editor.locale.contentLanguageDirection),
        d = a == "down" || a == "right",
        u = a == "up" || a == "down";
      if (c && r.isObject(c)) {
        var f = d ? l.getLastPosition() : l.getFirstPosition(),
          g = r.getNearestSelectionRange(f, d ? "forward" : "backward");
        g && (o.change(function (w) {
          w.setSelection(g);
        }), t.preventDefault(), e.stop());
        return;
      }
      if (!l.isCollapsed && !t.shiftKey) {
        var _f = l.getFirstPosition(),
          _g = l.getLastPosition(),
          w = _f.nodeAfter,
          E = _g.nodeBefore;
        (w && r.isObject(w) || E && r.isObject(E)) && (o.change(function (j) {
          j.setSelection(d ? _g : _f);
        }), t.preventDefault(), e.stop());
        return;
      }
      if (!l.isCollapsed) return;
      var h = this._getObjectElementNextToSelection(d);
      if (h && r.isObject(h)) {
        if (r.isInline(h) && u) return;
        this._setSelectionOverElement(h), t.preventDefault(), e.stop();
      }
    }
  }, {
    key: "_preventDefaultOnArrowKeyPress",
    value: function _preventDefaultOnArrowKeyPress(e, t) {
      var i = this.editor.model,
        o = i.schema,
        r = i.document.selection.getSelectedElement();
      r && o.isObject(r) && (t.preventDefault(), e.stop());
    }
  }, {
    key: "_handleDelete",
    value: function _handleDelete(e) {
      var _this1 = this;
      var i = this.editor.model.document.selection;
      if (!this.editor.model.canEditAt(i) || !i.isCollapsed) return;
      var o = this._getObjectElementNextToSelection(e);
      if (o) return this.editor.model.change(function (r) {
        var l = i.anchor.parent;
        for (; l.isEmpty;) {
          var c = l;
          l = c.parent, r.remove(c);
        }
        _this1._setSelectionOverElement(o);
      }), !0;
    }
  }, {
    key: "_setSelectionOverElement",
    value: function _setSelectionOverElement(e) {
      this.editor.model.change(function (t) {
        t.setSelection(t.createRangeOn(e));
      });
    }
  }, {
    key: "_getObjectElementNextToSelection",
    value: function _getObjectElementNextToSelection(e) {
      var t = this.editor.model,
        i = t.schema,
        o = t.document.selection,
        r = t.createSelection(o);
      if (t.modifySelection(r, {
        direction: e ? "forward" : "backward"
      }), r.isEqual(o)) return null;
      var l = e ? r.focus.nodeBefore : r.focus.nodeAfter;
      return l && i.isObject(l) ? l : null;
    }
  }, {
    key: "_clearPreviouslySelectedWidgets",
    value: function _clearPreviouslySelectedWidgets(e) {
      var _iterator8 = _createForOfIteratorHelper(this._previouslySelected),
        _step8;
      try {
        for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
          var t = _step8.value;
          e.removeClass(R, t);
        }
      } catch (err) {
        _iterator8.e(err);
      } finally {
        _iterator8.f();
      }
      this._previouslySelected.clear();
    }
  }, {
    key: "_selectFirstNestedEditable",
    value: function _selectFirstNestedEditable() {
      var e = this.editor,
        i = this.editor.editing.view.document;
      var _iterator9 = _createForOfIteratorHelper(i.selection.getFirstRange().getItems()),
        _step9;
      try {
        var _loop = function _loop() {
            var o = _step9.value;
            if (o.is("editableElement")) {
              var r = e.editing.mapper.toModelElement(o); /* istanbul ignore next -- @preserve */
              if (!r) return 0; // continue
              var l = e.model.createPositionAt(r, 0),
                c = e.model.schema.getNearestSelectionRange(l, "forward");
              return {
                v: (e.model.change(function (a) {
                  a.setSelection(c);
                }), !0)
              };
            }
          },
          _ret;
        for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
          _ret = _loop();
          if (_ret === 0) continue;
          if (_ret) return _ret.v;
        }
      } catch (err) {
        _iterator9.e(err);
      } finally {
        _iterator9.f();
      }
      return !1;
    }
  }, {
    key: "_selectAncestorWidget",
    value: function _selectAncestorWidget() {
      var e = this.editor,
        t = e.editing.mapper,
        o = e.editing.view.document.selection.getFirstPosition().parent,
        l = (o.is("$text") ? o.parent : o).findAncestor(m);
      if (!l) return !1;
      var c = t.toModelElement(l); /* istanbul ignore next -- @preserve */
      return c ? (e.model.change(function (a) {
        a.setSelection(c, "on");
      }), !0) : !1;
    }
  }], [{
    key: "pluginName",
    get: function get() {
      return "Widget";
    }
  }, {
    key: "isOfficialPlugin",
    get: function get() {
      return !0;
    }
  }, {
    key: "requires",
    get: function get() {
      return [Ce, I];
    }
  }]);
}(P);
function Ve(n) {
  var s = n;
  for (; s;) {
    if (s.is("editableElement") || m(s)) return s;
    s = s.parent;
  }
  return null;
}
function De(n, s) {
  var e = J(s.domEvent);
  var t = null;
  if (e ? t = n.domConverter.domRangeToView(e) : t = n.createRange(n.createPositionAt(s.target, 0)), !t) return null;
  var i = t.start;
  if (!i.parent) return null;
  var o = i.parent;
  return i.parent.is("editableElement") && (i.isAtEnd && i.nodeBefore ? o = i.nodeBefore : i.isAtStart && i.nodeAfter && (o = i.nodeAfter)), o.is("$text") ? o.parent : o;
}
function Ie(n, s) {
  return s ? Array.from(n.getAncestors()).includes(s) : !1;
}
function Oe(n, s) {
  var _iterator0 = _createForOfIteratorHelper(n.getAncestors({
      includeSelf: !0,
      parentFirst: !0
    })),
    _step0;
  try {
    for (_iterator0.s(); !(_step0 = _iterator0.n()).done;) {
      var e = _step0.value;
      if (s.checkChild(e, "$text")) return e;
      if (s.isLimit(e) && !s.isObject(e)) break;
    }
  } catch (err) {
    _iterator0.e(err);
  } finally {
    _iterator0.f();
  }
  return null;
}
function Fe(n, s) {
  var e = new q({
    startPosition: n
  });
  var _iterator1 = _createForOfIteratorHelper(e),
    _step1;
  try {
    for (_iterator1.s(); !(_step1 = _iterator1.n()).done;) {
      var _ref7 = _step1.value;
      var t = _ref7.item;
      if (s.isLimit(t) || !t.is("element")) return null;
      if (s.checkChild(t, "$text")) return t;
    }
  } catch (err) {
    _iterator1.e(err);
  } finally {
    _iterator1.f();
  }
  return null;
}
var ct = /*#__PURE__*/function (_P3) {
  function ct() {
    var _this10;
    _classCallCheck(this, ct);
    _this10 = _callSuper(this, ct, arguments);
    p(_this10, "_toolbarDefinitions", new Map());
    p(_this10, "_balloon");
    return _this10;
  }
  _inherits(ct, _P3);
  return _createClass(ct, [{
    key: "init",
    value: function init() {
      var _this11 = this;
      var e = this.editor;
      if (e.plugins.has("BalloonToolbar")) {
        var t = e.plugins.get("BalloonToolbar");
        this.listenTo(t, "show", function (i) {
          Ne(e.editing.view.document.selection) && i.stop();
        }, {
          priority: "high"
        });
      }
      this._balloon = this.editor.plugins.get("ContextualBalloon"), this.on("change:isEnabled", function () {
        _this11._updateToolbarsVisibility();
      }), this.listenTo(e.ui, "update", function () {
        _this11._updateToolbarsVisibility();
      }), this.listenTo(e.ui.focusTracker, "change:isFocused", function () {
        _this11._updateToolbarsVisibility();
      }, {
        priority: "low"
      });
    }
  }, {
    key: "destroy",
    value: function destroy() {
      _superPropGet(ct, "destroy", this, 3)([]);
      var _iterator10 = _createForOfIteratorHelper(this._toolbarDefinitions.values()),
        _step10;
      try {
        for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
          var e = _step10.value;
          e.view.destroy();
        }
      } catch (err) {
        _iterator10.e(err);
      } finally {
        _iterator10.f();
      }
    }
  }, {
    key: "register",
    value: function register(e, _ref8) {
      var _this12 = this;
      var t = _ref8.ariaLabel,
        i = _ref8.items,
        o = _ref8.getRelatedElement,
        _ref8$balloonClassNam = _ref8.balloonClassName,
        r = _ref8$balloonClassNam === void 0 ? "ck-toolbar-container" : _ref8$balloonClassNam,
        l = _ref8.positions;
      if (!i.length) {
        Y("widget-toolbar-no-items", {
          toolbarId: e
        });
        return;
      }
      var c = this.editor,
        a = c.t,
        d = new ne(c.locale);
      if (d.ariaLabel = t || a("Widget toolbar"), this._toolbarDefinitions.has(e)) throw new F("widget-toolbar-duplicated", this, {
        toolbarId: e
      });
      var u = {
        view: d,
        getRelatedElement: o,
        balloonClassName: r,
        itemsConfig: i,
        positions: l,
        initialized: !1
      };
      c.ui.addToolbar(d, {
        isContextual: !0,
        beforeFocus: function beforeFocus() {
          var h = o(c.editing.view.document.selection);
          h && _this12._showToolbar(u, h);
        },
        afterBlur: function afterBlur() {
          _this12._hideToolbar(u);
        }
      }), this._toolbarDefinitions.set(e, u);
    }
  }, {
    key: "_updateToolbarsVisibility",
    value: function _updateToolbarsVisibility() {
      var e = 0,
        t = null,
        i = null;
      var _iterator11 = _createForOfIteratorHelper(this._toolbarDefinitions.values()),
        _step11;
      try {
        for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
          var o = _step11.value;
          var r = o.getRelatedElement(this.editor.editing.view.document.selection);
          if (!this.isEnabled || !r) this._isToolbarInBalloon(o) && this._hideToolbar(o);else if (!this.editor.ui.focusTracker.isFocused) this._isToolbarVisible(o) && this._hideToolbar(o);else {
            var l = r.getAncestors().length;
            l > e && (e = l, t = r, i = o);
          }
        }
      } catch (err) {
        _iterator11.e(err);
      } finally {
        _iterator11.f();
      }
      i && this._showToolbar(i, t);
    }
  }, {
    key: "_hideToolbar",
    value: function _hideToolbar(e) {
      this._balloon.remove(e.view), this.stopListening(this._balloon, "change:visibleView");
    }
  }, {
    key: "_showToolbar",
    value: function _showToolbar(e, t) {
      var _this13 = this;
      this._isToolbarVisible(e) ? H(this.editor, t, e.positions) : this._isToolbarInBalloon(e) || (e.initialized || (e.initialized = !0, e.view.fillFromConfig(e.itemsConfig, this.editor.ui.componentFactory)), this._balloon.add({
        view: e.view,
        position: K(this.editor, t, e.positions),
        balloonClassName: e.balloonClassName
      }), this.listenTo(this._balloon, "change:visibleView", function () {
        var _iterator12 = _createForOfIteratorHelper(_this13._toolbarDefinitions.values()),
          _step12;
        try {
          for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
            var i = _step12.value;
            if (_this13._isToolbarVisible(i)) {
              var o = i.getRelatedElement(_this13.editor.editing.view.document.selection);
              H(_this13.editor, o, e.positions);
            }
          }
        } catch (err) {
          _iterator12.e(err);
        } finally {
          _iterator12.f();
        }
      }));
    }
  }, {
    key: "_isToolbarVisible",
    value: function _isToolbarVisible(e) {
      return this._balloon.visibleView === e.view;
    }
  }, {
    key: "_isToolbarInBalloon",
    value: function _isToolbarInBalloon(e) {
      return this._balloon.hasView(e.view);
    }
  }], [{
    key: "requires",
    get: function get() {
      return [oe];
    }
  }, {
    key: "pluginName",
    get: function get() {
      return "WidgetToolbarRepository";
    }
  }, {
    key: "isOfficialPlugin",
    get: function get() {
      return !0;
    }
  }]);
}(P);
function H(n, s, e) {
  var t = n.plugins.get("ContextualBalloon"),
    i = K(n, s, e);
  t.updatePosition(i);
}
function K(n, s, e) {
  var t = n.editing.view,
    i = se.defaultPositions;
  return {
    target: t.domConverter.mapViewToDom(s),
    positions: e || [i.northArrowSouth, i.northArrowSouthWest, i.northArrowSouthEast, i.southArrowNorth, i.southArrowNorthWest, i.southArrowNorthEast, i.viewportStickyNorth]
  };
}
function Ne(n) {
  var s = n.getSelectedElement();
  return !!(s && m(s));
}
var Me = /*#__PURE__*/function (_M) {
  function Me(e) {
    var _this14;
    _classCallCheck(this, Me);
    _this14 = _callSuper(this, Me);
    p(_this14, "_referenceCoordinates");
    p(_this14, "_options");
    p(_this14, "_originalWidth");
    p(_this14, "_originalHeight");
    p(_this14, "_originalWidthPercents");
    p(_this14, "_aspectRatio");
    _this14.set("activeHandlePosition", null), _this14.set("proposedWidthPercents", null), _this14.set("proposedWidth", null), _this14.set("proposedHeight", null), _this14.set("proposedHandleHostWidth", null), _this14.set("proposedHandleHostHeight", null), _this14._options = e, _this14._referenceCoordinates = null;
    return _this14;
  }
  _inherits(Me, _M);
  return _createClass(Me, [{
    key: "originalWidth",
    get: function get() {
      return this._originalWidth;
    }
  }, {
    key: "originalHeight",
    get: function get() {
      return this._originalHeight;
    }
  }, {
    key: "originalWidthPercents",
    get: function get() {
      return this._originalWidthPercents;
    }
  }, {
    key: "aspectRatio",
    get: function get() {
      return this._aspectRatio;
    }
  }, {
    key: "begin",
    value: function begin(e, t, i) {
      var o = new v(t);
      this.activeHandlePosition = Ke(e), this._referenceCoordinates = Le(t, je(this.activeHandlePosition)), this._originalWidth = o.width, this._originalHeight = o.height, this._aspectRatio = o.width / o.height;
      var r = i.style.width;
      r && r.match(/^\d+(\.\d*)?%$/) ? this._originalWidthPercents = parseFloat(r) : this._originalWidthPercents = ye(i, o);
    }
  }, {
    key: "update",
    value: function update(e) {
      this.proposedWidth = e.width, this.proposedHeight = e.height, this.proposedWidthPercents = e.widthPercents, this.proposedHandleHostWidth = e.handleHostWidth, this.proposedHandleHostHeight = e.handleHostHeight;
    }
  }]);
}(M());
function Le(n, s) {
  var e = new v(n),
    t = s.split("-"),
    i = {
      x: t[1] == "right" ? e.right : e.left,
      y: t[0] == "bottom" ? e.bottom : e.top
    };
  return i.x += n.ownerDocument.defaultView.scrollX, i.y += n.ownerDocument.defaultView.scrollY, i;
}
function Be(n) {
  return "ck-widget__resizer__handle-".concat(n);
}
function Ke(n) {
  var s = ["top-left", "top-right", "bottom-right", "bottom-left"];
  for (var _i3 = 0, _s = s; _i3 < _s.length; _i3++) {
    var e = _s[_i3];
    if (n.classList.contains(Be(e))) return e;
  }
}
function je(n) {
  var s = n.split("-"),
    e = {
      top: "bottom",
      bottom: "top",
      left: "right",
      right: "left"
    };
  return "".concat(e[s[0]], "-").concat(e[s[1]]);
}
var $e = /*#__PURE__*/function (_le) {
  function $e() {
    var _this15;
    _classCallCheck(this, $e);
    _this15 = _callSuper(this, $e);
    var s = _this15.bindTemplate;
    _this15.setTemplate({
      tag: "div",
      attributes: {
        class: ["ck", "ck-size-view", s.to("_viewPosition", function (e) {
          return e ? "ck-orientation-".concat(e) : "";
        })],
        style: {
          display: s.if("_isVisible", "none", function (e) {
            return !e;
          })
        }
      },
      children: [{
        text: s.to("_label")
      }]
    });
    return _this15;
  }
  _inherits($e, _le);
  return _createClass($e, [{
    key: "_bindToState",
    value: function _bindToState(s, e) {
      this.bind("_isVisible").to(e, "proposedWidth", e, "proposedHeight", function (t, i) {
        return t !== null && i !== null;
      }), this.bind("_label").to(e, "proposedHandleHostWidth", e, "proposedHandleHostHeight", e, "proposedWidthPercents", function (t, i, o) {
        return s.unit === "px" ? "".concat(t, "\xD7").concat(i) : "".concat(o, "%");
      }), this.bind("_viewPosition").to(e, "activeHandlePosition", e, "proposedHandleHostWidth", e, "proposedHandleHostHeight", function (t, i, o) {
        return i < 50 || o < 50 ? "above-center" : t;
      });
    }
  }, {
    key: "_dismiss",
    value: function _dismiss() {
      this.unbind(), this._isVisible = !1;
    }
  }]);
}(le);
var V = /*#__PURE__*/function (_M2) {
  function V(e) {
    var _this16;
    _classCallCheck(this, V);
    _this16 = _callSuper(this, V);
    p(_this16, "_state");
    p(_this16, "_sizeView");
    p(_this16, "_options");
    p(_this16, "_viewResizerWrapper", null);
    p(_this16, "_initialViewWidth");
    _this16._options = e, _this16.set("isEnabled", !0), _this16.set("isSelected", !1), _this16.bind("isVisible").to(_this16, "isEnabled", _this16, "isSelected", function (t, i) {
      return t && i;
    }), _this16.decorate("begin"), _this16.decorate("cancel"), _this16.decorate("commit"), _this16.decorate("updateSize"), _this16.on("commit", function (t) {
      !_this16.state.proposedWidth && !_this16.state.proposedWidthPercents && (_this16._cleanup(), t.stop());
    }, {
      priority: "high"
    });
    return _this16;
  }
  _inherits(V, _M2);
  return _createClass(V, [{
    key: "state",
    get: function get() {
      return this._state;
    }
  }, {
    key: "show",
    value: function show() {
      var _this17 = this;
      this._options.editor.editing.view.change(function (t) {
        t.removeClass("ck-hidden", _this17._viewResizerWrapper);
      });
    }
  }, {
    key: "hide",
    value: function hide() {
      var _this18 = this;
      this._options.editor.editing.view.change(function (t) {
        t.addClass("ck-hidden", _this18._viewResizerWrapper);
      });
    }
  }, {
    key: "attach",
    value: function attach() {
      var _this19 = this;
      var e = this,
        t = this._options.viewElement;
      this._options.editor.editing.view.change(function (o) {
        var r = o.createUIElement("div", {
          class: "ck ck-reset_all ck-widget__resizer"
        }, function (l) {
          var c = this.toDomElement(l);
          return e._appendHandles(c), e._appendSizeUI(c), c;
        });
        o.insert(o.createPositionAt(t, "end"), r), o.addClass("ck-widget_with-resizer", t), _this19._viewResizerWrapper = r, _this19.isVisible || _this19.hide();
      }), this.on("change:isVisible", function () {
        _this19.isVisible ? (_this19.show(), _this19.redraw()) : _this19.hide();
      });
    }
  }, {
    key: "begin",
    value: function begin(e) {
      this._state = new Me(this._options), this._sizeView._bindToState(this._options, this.state), this._initialViewWidth = this._options.viewElement.getStyle("width"), this.state.begin(e, this._getHandleHost(), this._getResizeHost());
    }
  }, {
    key: "updateSize",
    value: function updateSize(e) {
      var _this20 = this;
      var t = this._proposeNewSize(e);
      this._options.editor.editing.view.change(function (d) {
        var u = _this20._options.unit || "%",
          h = (u === "%" ? t.widthPercents : t.width) + u;
        d.setStyle("width", h, _this20._options.viewElement);
      });
      var o = this._getHandleHost(),
        r = new v(o),
        l = Math.round(r.width),
        c = Math.round(r.height),
        a = new v(o);
      t.width = Math.round(a.width), t.height = Math.round(a.height), this.redraw(r), this.state.update(_objectSpread(_objectSpread({}, t), {}, {
        handleHostWidth: l,
        handleHostHeight: c
      }));
    }
  }, {
    key: "commit",
    value: function commit() {
      var _this21 = this;
      var e = this._options.unit || "%",
        t = (e === "%" ? this.state.proposedWidthPercents : this.state.proposedWidth) + e;
      this._options.editor.editing.view.change(function () {
        _this21._cleanup(), _this21._options.onCommit(t);
      });
    }
  }, {
    key: "cancel",
    value: function cancel() {
      this._cleanup();
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.cancel();
    }
  }, {
    key: "redraw",
    value: function redraw(e) {
      var t = this._domResizerWrapper;
      if (!Ge(t)) return;
      var i = t.parentElement,
        o = this._getHandleHost(),
        r = this._viewResizerWrapper,
        l = [r.getStyle("width"), r.getStyle("height"), r.getStyle("left"), r.getStyle("top")];
      var c;
      if (i.isSameNode(o)) {
        var a = e || new v(o);
        c = [a.width + "px", a.height + "px", void 0, void 0];
      } else c = [o.offsetWidth + "px", o.offsetHeight + "px", o.offsetLeft + "px", o.offsetTop + "px"];
      Z(l, c) !== "same" && this._options.editor.editing.view.change(function (a) {
        a.setStyle({
          width: c[0],
          height: c[1],
          left: c[2],
          top: c[3]
        }, r);
      });
    }
  }, {
    key: "containsHandle",
    value: function containsHandle(e) {
      return this._domResizerWrapper.contains(e);
    }
  }, {
    key: "_cleanup",
    value: function _cleanup() {
      var _this22 = this;
      this._sizeView._dismiss(), this._options.editor.editing.view.change(function (t) {
        t.setStyle("width", _this22._initialViewWidth, _this22._options.viewElement);
      });
    }
  }, {
    key: "_proposeNewSize",
    value: function _proposeNewSize(e) {
      var t = this.state,
        i = qe(e),
        o = this._options.isCentered ? this._options.isCentered(this) : !0,
        r = {
          x: t._referenceCoordinates.x - (i.x + t.originalWidth),
          y: i.y - t.originalHeight - t._referenceCoordinates.y
        };
      o && t.activeHandlePosition.endsWith("-right") && (r.x = i.x - (t._referenceCoordinates.x + t.originalWidth)), o && (r.x *= 2);
      var l = Math.abs(t.originalWidth + r.x),
        c = Math.abs(t.originalHeight + r.y);
      return (l / t.aspectRatio > c ? "width" : "height") == "width" ? c = l / t.aspectRatio : l = c * t.aspectRatio, {
        width: Math.round(l),
        height: Math.round(c),
        widthPercents: Math.min(Math.round(t.originalWidthPercents / t.originalWidth * l * 100) / 100, 100)
      };
    }
  }, {
    key: "_getResizeHost",
    value: function _getResizeHost() {
      var e = this._domResizerWrapper.parentElement;
      return this._options.getResizeHost(e);
    }
  }, {
    key: "_getHandleHost",
    value: function _getHandleHost() {
      var e = this._domResizerWrapper.parentElement;
      return this._options.getHandleHost(e);
    }
  }, {
    key: "_domResizerWrapper",
    get: function get() {
      return this._options.editor.editing.view.domConverter.mapViewToDom(this._viewResizerWrapper);
    }
  }, {
    key: "_appendHandles",
    value: function _appendHandles(e) {
      var t = ["top-left", "top-right", "bottom-right", "bottom-left"];
      for (var _i4 = 0, _t = t; _i4 < _t.length; _i4++) {
        var i = _t[_i4];
        e.appendChild(new k({
          tag: "div",
          attributes: {
            class: "ck-widget__resizer__handle ".concat(Ue(i))
          }
        }).render());
      }
    }
  }, {
    key: "_appendSizeUI",
    value: function _appendSizeUI(e) {
      this._sizeView = new $e(), this._sizeView.render(), e.appendChild(this._sizeView.element);
    }
  }], [{
    key: "isResizeHandle",
    value: function isResizeHandle(e) {
      return e.classList.contains("ck-widget__resizer__handle");
    }
  }]);
}(M());
function Ue(n) {
  return "ck-widget__resizer__handle-".concat(n);
}
function qe(n) {
  return {
    x: n.pageX,
    y: n.pageY
  };
}
function Ge(n) {
  return n && n.ownerDocument && n.ownerDocument.contains(n);
}
var at = /*#__PURE__*/function (_P4) {
  function at() {
    var _this23;
    _classCallCheck(this, at);
    _this23 = _callSuper(this, at, arguments);
    p(_this23, "_resizers", new Map());
    p(_this23, "_observer");
    p(_this23, "_redrawSelectedResizerThrottled");
    return _this23;
  }
  _inherits(at, _P4);
  return _createClass(at, [{
    key: "init",
    value: function init() {
      var _this24 = this;
      var e = this.editor.editing,
        t = A.window.document;
      this.set("selectedResizer", null), this.set("_activeResizer", null), e.view.addObserver(D), this._observer = new (Q())(), this.listenTo(e.view.document, "mousedown", this._mouseDownListener.bind(this), {
        priority: "high"
      }), this._observer.listenTo(t, "mousemove", this._mouseMoveListener.bind(this)), this._observer.listenTo(t, "mouseup", this._mouseUpListener.bind(this)), this._redrawSelectedResizerThrottled = ae(function () {
        return _this24.redrawSelectedResizer();
      }, 200), this.editor.ui.on("update", this._redrawSelectedResizerThrottled), this.editor.model.document.on("change", function () {
        var _iterator13 = _createForOfIteratorHelper(_this24._resizers),
          _step13;
        try {
          for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
            var _ref9 = _step13.value;
            var _ref0 = _slicedToArray(_ref9, 2);
            var o = _ref0[0];
            var r = _ref0[1];
            o.isAttached() || (_this24._resizers.delete(o), r.destroy());
          }
        } catch (err) {
          _iterator13.e(err);
        } finally {
          _iterator13.f();
        }
      }, {
        priority: "lowest"
      }), this._observer.listenTo(A.window, "resize", this._redrawSelectedResizerThrottled);
      var i = this.editor.editing.view.document.selection;
      i.on("change", function () {
        var o = i.getSelectedElement(),
          r = _this24.getResizerByViewElement(o) || null;
        r ? _this24.select(r) : _this24.deselect();
      });
    }
  }, {
    key: "redrawSelectedResizer",
    value: function redrawSelectedResizer() {
      this.selectedResizer && this.selectedResizer.isVisible && this.selectedResizer.redraw();
    }
  }, {
    key: "destroy",
    value: function destroy() {
      _superPropGet(at, "destroy", this, 3)([]), this._observer.stopListening();
      var _iterator14 = _createForOfIteratorHelper(this._resizers.values()),
        _step14;
      try {
        for (_iterator14.s(); !(_step14 = _iterator14.n()).done;) {
          var e = _step14.value;
          e.destroy();
        }
      } catch (err) {
        _iterator14.e(err);
      } finally {
        _iterator14.f();
      }
      this._redrawSelectedResizerThrottled.cancel();
    }
  }, {
    key: "select",
    value: function select(e) {
      this.deselect(), this.selectedResizer = e, this.selectedResizer.isSelected = !0;
    }
  }, {
    key: "deselect",
    value: function deselect() {
      this.selectedResizer && (this.selectedResizer.isSelected = !1), this.selectedResizer = null;
    }
  }, {
    key: "attachTo",
    value: function attachTo(e) {
      var t = new V(e),
        i = this.editor.plugins;
      if (t.attach(), i.has("WidgetToolbarRepository")) {
        var l = i.get("WidgetToolbarRepository");
        t.on("begin", function () {
          l.forceDisabled("resize");
        }, {
          priority: "lowest"
        }), t.on("cancel", function () {
          l.clearForceDisabled("resize");
        }, {
          priority: "highest"
        }), t.on("commit", function () {
          l.clearForceDisabled("resize");
        }, {
          priority: "highest"
        });
      }
      this._resizers.set(e.viewElement, t);
      var r = this.editor.editing.view.document.selection.getSelectedElement();
      return this.getResizerByViewElement(r) == t && this.select(t), t;
    }
  }, {
    key: "getResizerByViewElement",
    value: function getResizerByViewElement(e) {
      return this._resizers.get(e);
    }
  }, {
    key: "_getResizerByHandle",
    value: function _getResizerByHandle(e) {
      var _iterator15 = _createForOfIteratorHelper(this._resizers.values()),
        _step15;
      try {
        for (_iterator15.s(); !(_step15 = _iterator15.n()).done;) {
          var t = _step15.value;
          if (t.containsHandle(e)) return t;
        }
      } catch (err) {
        _iterator15.e(err);
      } finally {
        _iterator15.f();
      }
    }
  }, {
    key: "_mouseDownListener",
    value: function _mouseDownListener(e, t) {
      var i = t.domTarget;
      V.isResizeHandle(i) && (this._activeResizer = this._getResizerByHandle(i) || null, this._activeResizer && (this._activeResizer.begin(i), e.stop(), t.preventDefault()));
    }
  }, {
    key: "_mouseMoveListener",
    value: function _mouseMoveListener(e, t) {
      this._activeResizer && this._activeResizer.updateSize(t);
    }
  }, {
    key: "_mouseUpListener",
    value: function _mouseUpListener() {
      this._activeResizer && (this._activeResizer.commit(), this._activeResizer = null);
    }
  }], [{
    key: "pluginName",
    get: function get() {
      return "WidgetResize";
    }
  }, {
    key: "isOfficialPlugin",
    get: function get() {
      return !0;
    }
  }]);
}(P);
export { ue as WIDGET_CLASS_NAME, R as WIDGET_SELECTED_CLASS_NAME, lt as Widget, at as WidgetResize, ct as WidgetToolbarRepository, Ce as WidgetTypeAround, be as calculateResizeHostAncestorWidth, ye as calculateResizeHostPercentageWidth, rt as findOptimalInsertionRange, me as getLabel, m as isWidget, L as setHighlightHandling, fe as setLabel, nt as toWidget, st as toWidgetEditable };